export default {
    ml: [2000, 2250, 2500, 2750, 3000],
    oz: [64, 72, 80, 88, 96],
};
